export default __webpack_public_path__ + "static/sms-hover-581e197de2748fe192fda2a865c2ed39.webp";